import React, { useState } from 'react';
import { Button } from "@mui/material";
import { ChevronDown, ChevronUp } from "lucide-react";
import './Synthese.css';

const Synthese = ({ decisionData }) => {
    const [showDetails, setShowDetails] = useState(false);

    if (!decisionData) return null;

    return (
        <div id="synthese" className="content-section">
            <div className="synthese-content">
                <div id="basic" className="section">
                    {decisionData?.objet_litige && <p className="mb-4 litige-text">{decisionData?.objet_litige}</p>}
                </div>

                <div id="juridiction" className="section mb-4">
                    <h3 className="section-subtitle">Juridiction</h3>
                    {decisionData?.juridiction?.nom && <p className="info-text">{decisionData?.juridiction?.nom}</p>}
                    {decisionData?.juridiction?.chambre && <p className="info-text">Chambre: {decisionData?.juridiction?.chambre}</p>}
                </div>

                <div id="date" className="section mb-4">
                    <h3 className="section-subtitle">Date d'audience</h3>
                    {decisionData?.audience?.date && (
                        <p className="info-text">{new Date(decisionData?.audience?.date).toLocaleDateString('fr-FR', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric'
                        }).replace(/\//g, '-')}</p>
                    )}
                </div>

                <div id="dispositif" className="section mb-4">
                    <h3 className="section-subtitle">Dispositif</h3>
                    {decisionData.dispositif && <p className="info-text">{decisionData.dispositif}</p>}
                </div>

                <div id="parties" className="section mb-4">
                    <h3 className="section-subtitle">Parties</h3>
                    {decisionData?.parties?.map((party) => (
                        <div key={party.id} className="party-info mb-4">
                            {party.role && <h4 className="party-role">{party.role.toUpperCase()}</h4>}
                            {party?.nom && <p className="info-text"><strong>Nom :</strong> {party?.nom}</p>}
                            {party?.immatriculation && (
                                <p className="info-text"><strong>Immatriculation :</strong> {party?.immatriculation}</p>
                            )}
                            {party?.avocat && (
                                <p className="info-text"><strong>Avocat :</strong> {party?.avocat}</p>
                            )}
                            {party?.representant_legal && (
                                <p className="info-text"><strong>Représentant légal :</strong> {party?.representant_legal}</p>
                            )}
                        </div>
                    ))}
                </div>

                <Button
                    onClick={() => setShowDetails(!showDetails)}
                    className="details-toggle"
                >
                    {showDetails ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                    {showDetails ? "Voir moins" : "Voir plus"}
                </Button>

                {showDetails && (
                    <div id="details" className="section details-section">
                        <h3 className="section-subtitle">Détails de l'audience</h3>
                        {decisionData?.audience?.greffier && <p className="info-text"><strong>Greffier:</strong> {decisionData.audience.greffier}</p>}

                        {decisionData?.audience?.membres && decisionData?.audience?.membres.length > 0 && (
                            <>
                                <h4 className="members-title">Membres du tribunal</h4>
                                {decisionData?.audience?.membres.map((membre, index) => (
                                    <div key={index} className="membre-info">
                                        {membre?.role && membre?.nom && (
                                            <p className="info-text"><strong>{membre?.role}:</strong> {membre?.nom}</p>
                                        )}
                                    </div>
                                ))}
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Synthese;